// Stores the brand an agent is working on.

import { atomWithStorage } from 'jotai/utils';

/** A brand is an account — the one the user is logged into. */
export interface WorkspaceBrand {
	id: number;
	name: string;
}

/** Persisted so a reload keeps it; an account switch replaces it. */
export const SELECTED_BRAND_KEY = 'kim-sentinel-brand';

/** `getOnInit` reads storage on first render, so the workspace does not flash its loading state. */
export const selectedBrandAtom = atomWithStorage<WorkspaceBrand | null>(SELECTED_BRAND_KEY, null, undefined, {
	getOnInit: true
});
